import script from './GenericSubNav.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-subnav"},[_c('button',{staticClass:"mobile-subnav__item"},[_c('router-link',{staticClass:"mobile-subnav__item-wrapper",attrs:{"to":{ name: _vm.routeName },"tag":"div"}},[_c('Icon',{class:_vm.iconClass,attrs:{"size":"md"}}),_vm._v(" "),_c('div',{staticClass:"mobile-subnav__item-text"},[_vm._v("\n                    "+_vm._s(_vm.text)+"\n                ")])],1)],1)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5e84008f_0", { source: ".mobile-subnav__item[data-v-5e84008f]{position:relative;display:flex;align-items:center;justify-content:space-between;cursor:pointer;outline:0;border:none;border-right:1px solid #a82217;background-color:#c81e10;flex:1;padding:0 16px;z-index:2;overflow:hidden}.mobile-subnav__item[data-v-5e84008f]:first-child{padding-left:max(16px,env(safe-area-inset-left))}.mobile-subnav__item[data-v-5e84008f] .flag{margin-bottom:0;flex:1 0 auto}.mobile-subnav__item[data-v-5e84008f] .icon{margin-right:4px;color:#fff;opacity:.8;vertical-align:middle;flex:0 0 20px}.mobile-subnav__item-wrapper[data-v-5e84008f]{display:flex;align-items:center;overflow:hidden;width:100%}.mobile-subnav__item-text[data-v-5e84008f]{color:#fff;font-size:14px;font-weight:600;text-transform:uppercase;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-5e84008f";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
